<template>
  <main>
    <div class="internal-content">
      <b-container>
        <b-row align-h="center">
          <b-col lg="3" sm="6">
            <b-button @click="voltar" class="btn btn-primary" style="width: 100%">
              Voltar
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <img src="../../../assets/imagens/404.jpg" alt="Imóvel não encontrado" style="max-width: 100%" />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </main>
</template>

<script>
export default {
  methods: {
    voltar() {
      this.$router.replace('/');
    },
  },
}
</script>